// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
    position: relative;
  }
  
  .carousel-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
  }
  
  .cprev-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #0e497a;
    /* opacity: 0.6; */
    color: white;
    border: 1px solid #0e497a;
    padding: 10px 9px;
    cursor: pointer;
    border-radius: 1px 16px 16px 0px;
    left: 0;
    box-shadow: -3px 2px 10px rgb(0 0 0 / 0.2);
  }
  
  .cnext-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #0e497a;
    /* opacity: 0.6; */
    color: white;
    border: 1px solid #0e497a;
    padding: 10px 9px;
    cursor: pointer;
    border-radius: 16px 1px 3px 16px;
    right : 0;
    box-shadow: -3px 2px 10px rgb(0 0 0 / 0.2);
    /* font-size: 23px */
  }`, "",{"version":3,"sources":["webpack://./src/pages/AuditHomePage/NCSummary/slider-carousel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,OAAO;IACP,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,0CAA0C;IAC1C,oBAAoB;EACtB","sourcesContent":[".carousel-container {\n    position: relative;\n  }\n  \n  .carousel-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n  }\n  \n  .cprev-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #0e497a;\n    /* opacity: 0.6; */\n    color: white;\n    border: 1px solid #0e497a;\n    padding: 10px 9px;\n    cursor: pointer;\n    border-radius: 1px 16px 16px 0px;\n    left: 0;\n    box-shadow: -3px 2px 10px rgb(0 0 0 / 0.2);\n  }\n  \n  .cnext-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #0e497a;\n    /* opacity: 0.6; */\n    color: white;\n    border: 1px solid #0e497a;\n    padding: 10px 9px;\n    cursor: pointer;\n    border-radius: 16px 1px 3px 16px;\n    right : 0;\n    box-shadow: -3px 2px 10px rgb(0 0 0 / 0.2);\n    /* font-size: 23px */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
